import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { homeRoute } from '@app-constants/app.constants';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { SignupService } from '@app-services/signup/signup.service';
import { states } from '@subscription-constants/subscriptionconstant';
import { param } from 'jquery';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css', '../payment/payment.component.css']
})
export class RegistrationComponent implements OnInit {

  urlData;
  states = states
  userInfoForm!: FormGroup
  selectedState :any
  grades: any[];
  gradeId;
  constructor(private router: ActivatedRoute, private route: Router,
    private fb: FormBuilder, private signUpService: SignupService,
    private targetExamService: BoardsService) {
    this.router.queryParams.subscribe(params => {
      this.urlData = params
      console.log(this.urlData)
    })
    localStorage.setItem('logData', JSON.stringify(this.urlData));
  }

  ngOnInit(): void {
    this.userInfoForm = this.fb.group({
      username: ['', [Validators.required]],
      phone: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
      email: ['', [Validators.email, Validators.required]],
      state:['', [Validators.required]]
    })

    this.fetchGradesList()
    if (!Object.keys(this.urlData).length) {
      window.location.href = homeRoute
    }
  }
  get form() { return this.userInfoForm.controls }

  fetchGradesList() {
    this.targetExamService.fetchGradesList().subscribe((data: any) => {
      this.grades = data;
      if ( this.grades.length > 0){
        this.grades.filter((grade) => {
          if(grade.name.includes(this.urlData.grade)){
            this.gradeId = grade.gradeId
          }
        })
      } else {
        window.location.href = homeRoute
      }
    });
  }
  formSubmit() {
    let data = {
      dialCode: '+91',
      phone: this.userInfoForm.value.phone,
      firstName: this.userInfoForm.value.username.split(' ')[0],
      lastName: this.userInfoForm.value.username.split(' ')[1] ? this.userInfoForm.value.username.split(' ')[1] : null,
      whatsappConsent: false,
      gradeId: this.gradeId,
      grade: this.urlData.grade,
      examName: this.urlData.courses,
      batchid: this.urlData.batchid,
      state: this.selectedState,
      email: this.userInfoForm.value.email
    }
    localStorage.setItem('logData', JSON.stringify(data));
    console.log(data)
    this.signUpService.generateOtp(data, '+91').subscribe((data: any) => {
      if (data) {
        this.route.navigateByUrl('/courses/otp', { state: this.urlData })
      }
    });
    // if (!this.showAccountExist) {
    //   let data = {
    //     dialCode: "+91",
    //     number: this.userInfoForm.value.phone
    //   }
    //   this.signUpService.verifyPhoneNumber(data).subscribe((data) => {
    //   if (data.existingUser === false) {
    //     localStorage.setItem('signupUser', JSON.stringify(this.signupForm.value));
    //     this.router.navigateByUrl('/veirfy-otp', { state: { register: true } });
    //   }
    // })
    // }
  }
  selectState(event){ 
    console.log(this.userInfoForm.value.state)
    this.selectedState =  this.states.find((val)=>val.name  == this.userInfoForm.value.state) 
    // console.log(findstate)
  }

}
